import script from "./Overview.vue?vue&type=script&setup=true&lang=js"
export * from "./Overview.vue?vue&type=script&setup=true&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=820bcf9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-820bcf9c"]])

export default __exports__